import { FC, useContext, useEffect } from 'react';
import { AuthContext } from '../../app/authentication/AuthServiceProvider';

const SilentAuthCallbackPage: FC = () => {
    const userManager = useContext(AuthContext);
    useEffect(() => { userManager.signinSilentCallback(); }, [userManager]);

    return (<></>);
};

export default SilentAuthCallbackPage;